module.exports = __webpack_public_path__ + "img/mobile-anti-drooling-title.b8b218ab.svg";